import { CustomersTable } from '@/components/features/customers'

export const Customers = () => {
  return <CustomersTable />
}
